export default {
  namespaced: true,
  state: {
    medicineId:null,
  },
  getters: {
    medicineId: state => state.medicineId,
  },
  mutations: {
    // 存储药物id
    setMedicineId(state, medicineId) {
      state.phoneModel = medicineId;
    },
  },
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js